import { Component, inject } from '@angular/core';
import { ApplicationCommonComponent } from '../../../common/application.common.component';
import { MunicipalWasteDisposalBaseInfoForm } from './forms/municipal-waste-disposal-base-info.form';
import { ApplicationAppEntityApplicationRead } from '../../../../../../openapi';
import { StagesComponent } from '../../../../../../common/stages/stages.component';
import { stages } from '../../municipal-waste-disposal.routes';
import { ReactiveFormsModule } from '@angular/forms';
import { SpinnerComponent } from '../../../../../../common/spinner/spinner.component';
import { CommonModule } from '@angular/common';
import { ValidationErrorsComponent } from '../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-municipal-waste-disposal-base-info-section',
  standalone: true,
  imports: [
    StagesComponent,
    ReactiveFormsModule,
    SpinnerComponent,
    CommonModule,
    ValidationErrorsComponent
  ],
  providers: [MunicipalWasteDisposalBaseInfoForm],
  templateUrl: './municipal-waste-disposal-base-info-section.component.html'
})
export class MunicipalWasteDisposalBaseInfoSectionComponent extends ApplicationCommonComponent {

  public stages: string[] = stages;

  public form: MunicipalWasteDisposalBaseInfoForm = inject(MunicipalWasteDisposalBaseInfoForm);

  public override onFetchApplicationData = (app: ApplicationAppEntityApplicationRead | null) => {
    if (app) {
      this.form.patchFormValues({
        ...app
      });
    }
  };

  public submitAndGoNext(): void {
    if (this.form.valid) {
      if (this.applicationId) {
        this.updateApplication('dane-identyfikacyjne', this.form.value);
      } else {
        this.createApplication('dane-identyfikacyjne', this.form.value);
      }
    } else {
      this.form.markAllAsTouched();
    }
  }
}
